(() => {
  const bind = () => {
    const card = document.querySelector('ps-purchase-card');
    const bar = document.querySelector('[data-ps-sticky]');
    if (!card || !bar || bar.dataset.bound) return;
    bar.dataset.bound = 'true';
    const target = bar.querySelector('[data-ps-sticky-price]');
    const update = () => {
      const price = card.querySelector('.price--on-sale .price-item--sale') || card.querySelector('.price__regular .price-item--regular');
      if (price && target && target.textContent !== price.textContent.trim()) target.textContent = price.textContent.trim();
    };
    new MutationObserver(update).observe(card, { childList: true, subtree: true, characterData: true });
    update();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        const show = entries[0].boundingClientRect.bottom < 0;
        bar.hidden = !show;
        document.body.classList.toggle('ps-sticky-visible', show);
      }, { threshold: 0 }).observe(card);
    }
  };
  document.addEventListener('DOMContentLoaded', bind, { once: true });
  document.addEventListener('shopify:section:load', bind);
})();
